import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { ConditionalWrapper } from '~/components/Shared/Utility/ConditionalWrapper/ConditionalWrapper';

const cssClasses = cva('max-md:px-[20px] mx-auto', {
  variants: {
    width: {
      sm: 'max-w-[700px]',
      default: 'max-w-[800px]',
    },
  },
});

type PremiumArticleProps = {
  width?: 'sm' | 'default';
  relativeWrapper?: boolean;
};

const RelativeWrapper = component$(() => {
  return (
    <div class='relative'>
      <Slot />
    </div>
  );
});

export default component$<PremiumArticleProps>(
  ({ width = 'default', relativeWrapper = false }): JSX.Element => {
    return (
      <ConditionalWrapper
        component={RelativeWrapper}
        condition={relativeWrapper}
      >
        <main class={cssClasses({ width })}>
          <div class='viewablity-block'>
            <Slot />
          </div>
        </main>
      </ConditionalWrapper>
    );
  }
);
